import React, { Suspense } from 'react'
import { EmptyContent } from '../EmptyContent'
import { LoadingContent } from '../loading/LoadingContent'
import { ErrorContent } from '../ErrorContent'

export type DataSuspenseProps = {
  loadingComponent?: React.ReactNode
  emptyComponent?: React.ReactNode
  errorComponent?: React.ReactNode
  children: any
  isEmpty?: boolean
  error?: any
  loading?: boolean
  useNative?: boolean
}
export const DataSuspense = ({
  loadingComponent,
  emptyComponent,
  errorComponent,
  children,
  isEmpty,
  error,
  loading = false,
  useNative = false,
}: DataSuspenseProps) => {
  if (useNative) {
    return <NativeSuspense loadingComponent={loadingComponent}>{children}</NativeSuspense>
  }

  loadingComponent = loadingComponent ?? <LoadingContent />
  emptyComponent = emptyComponent ?? <EmptyContent message="Empty data." subMessage="No information is available now!" />
  errorComponent = errorComponent ?? <ErrorContent error={error} />

  //because we are using the cache-and-network policy, sometime the document already exists in the cache
  //so the loading can be true, but because there is cache value, we need to check it
  //if (loading === true && isEmpty === true) {
  //NOTE: Override the logic above, in-favor for cache first implementation
  //as long it is loading, then we really show the loading components
  //the above statement (above the NOTE) is the implementation during the cache-and-network policy, but when change it to cache first policy,
  // then we need change override the logic above
  if (loading === true) {
    //as long is still loading show the loading component
    return loadingComponent
  } else {
    //when it is not loading check if it is an error
    if (error) {
      return errorComponent
    }
    //if it is empty show the empty component
    else if (isEmpty && loading === false) {
      return emptyComponent
    }
    //not error, not empty, not loading show the children
    else {
      return children
    }
  }
}

export const NativeSuspense = ({ loadingComponent, children }) => {
  loadingComponent = loadingComponent ?? <LoadingContent />

  return <Suspense fallback={loadingComponent}>{children}</Suspense>
}
